import { getToken } from "@/utils/storage";
import { stripeFinishPay } from "@/api/pay";
//TODO 要换成实际应用api key。This is your test publishable API key.
//pk_live_51KZpXGIv2DNpq1CYSxBwRtD8QxAEBxr9sGlLro4Jppn3Ui4X7BcHCo7rm9z45KLomsjaZxqmrQ7hqM8zji3hK54100YBmUjUeY
//pk_test_51KZpXGIv2DNpq1CYZezCoCfNuCaihSj8QYAfdWtRxIxQMoXM4bb4ZpdThAfFtw8ZxQOLi67IExUUsEqxhN3fYKlR005ucGHrnm
const stripe = Stripe(
  "pk_live_51KZpXGIv2DNpq1CYSxBwRtD8QxAEBxr9sGlLro4Jppn3Ui4X7BcHCo7rm9z45KLomsjaZxqmrQ7hqM8zji3hK54100YBmUjUeY"
);

// const stripe = Stripe(
//   "pk_test_51KZpXGIv2DNpq1CYZezCoCfNuCaihSj8QYAfdWtRxIxQMoXM4bb4ZpdThAfFtw8ZxQOLi67IExUUsEqxhN3fYKlR005ucGHrnm"
// );

//TODO 用户购买物品参数 The items the customer wants to buy
//const order_price = 3000;

let elements;

// initialize();
// checkStatus();

// document
//   .querySelector("#payment-form")
//   .addEventListener("submit", handleSubmit);

// Fetches a payment intent and captures the client secret
async function initialize(params) {
  //向我们服务接口请求返回一个clientSecret 改成调用stripeReadyPay接口
  const response = await fetch(window.baseUrl + "/api/pay/stripeReadyPay", {
    method: "POST",
    headers: { "Content-Type": "application/json", Authorization: getToken() },
    body: JSON.stringify(params),
  });
  const { clientSecret } = await response.json();

  const appearance = {
    theme: "stripe",
  };

  //加载支付UI元素
  elements = stripe.elements({ locale: "en", appearance, clientSecret });

  const paymentElement = elements.create("payment");
  paymentElement.mount("#payment-element");
}

async function handleSubmit(e) {
  e.preventDefault();
  //setLoading(true);

  const { error } = await stripe.confirmPayment({
    elements,
    confirmParams: {
      //TODO 付款完成跳转页面
      // Make sure to change this to your payment completion page
      return_url: window.location.href,
    },
  });

  //付款出错才会走到下面，进行错误提示
  // This point will only be reached if there is an immediate error when
  // confirming the payment. Otherwise, your customer will be redirected to
  // your `return_url`. For some payment methods like iDEAL, your customer will
  // be redirected to an intermediate site first to authorize the payment, then
  // redirected to the `return_url`.
  if (error.type === "card_error" || error.type === "validation_error") {
    showMessage(error.message);
  } else {
    showMessage("An unexpected error occured.");
  }

  //setLoading(false);
}

//在提交付款后获取付款意图状态
// Fetches the payment intent status after payment submission
async function checkStatus() {
  const clientSecret = new URLSearchParams(window.location.search).get(
    "payment_intent_client_secret"
  );

  if (!clientSecret) {
    return;
  }

  const { paymentIntent } = await stripe.retrievePaymentIntent(clientSecret);
  switch (paymentIntent.status) {
    case "succeeded":
      alert("Payment processing!");
      //TODO 支付成功，在这里调支付成功的接口 stripeFinishPay
      window.location = "https://www.getstocks.cc/pay";
      // stripeFinishPay(paymentIntent)
      //   .then((result) => {
          
      //   })
      //   .catch((error) => {});
      break;
    case "processing":
      alert("Your payment is processing.");
      break;
    case "requires_payment_method":
      alert("Your payment was not successful, please try again.");
      break;
    default:
      alert("Something went wrong.");
      break;
  }
}

function initLinsten() {
  document
    .querySelector("#payment-form")
    .addEventListener("submit", handleSubmit);
}

// ------- UI helpers -------
function showMessage(messageText) {
  const messageContainer = document.querySelector("#payment-message");

  messageContainer.classList.remove("hidden");
  messageContainer.textContent = messageText;

  setTimeout(function () {
    messageContainer.classList.add("hidden");
    messageText.textContent = "";
  }, 4000);
}

// Show a spinner on payment submission
function setLoading(isLoading) {
  if (isLoading) {
    // Disable the button and show a spinner
    document.querySelector("#submit").disabled = true;
    document.querySelector("#spinner").classList.remove("hidden");
    document.querySelector("#button-text").classList.add("hidden");
  } else {
    document.querySelector("#submit").disabled = false;
    document.querySelector("#spinner").classList.add("hidden");
    document.querySelector("#button-text").classList.remove("hidden");
  }
}

export { initLinsten, initialize, checkStatus };
